import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Button, Text, Modal } from '@adc/ui-adc'
import { enums } from '@adc/sdk'
import styles from '../../scss/config.scss'
const cx = classnames.bind(styles)

const postponedAuctionContent = {
  title: 'Auction Postponed',
  content: 'This auction has been postponed.',
}
const MAP = {
  [enums.ListingStatus.Postponed]: postponedAuctionContent,
  [enums.ListingStatus.PostponedPendingScheduling]: postponedAuctionContent,
  [enums.ListingStatus.Canceled]: {
    title: 'Auction Canceled',
    content: 'This auction has been canceled.',
  },
}

export default class AuctionStatusNotification extends React.Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
  }

  state = {
    isModalOpen: false,
  }

  componentDidUpdate(prevProps) {
    const { listing } = this.props
    if (
      (listing.__methods__.isPostponed() &&
        !prevProps.listing.__methods__.isPostponed()) ||
      (listing.__methods__.isCancelled() &&
        !prevProps.listing.__methods__.isCancelled())
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isModalOpen: true,
      })
    }
  }

  handleClose = () => {
    const { listing } = this.props
    const eventCode = listing.event?.event_code
    if (listing.__methods__.isCancelled() && eventCode) {
      window.location.assign(
        `/residential/${eventCode}_qs/pending,closed,canceled_lt/?msgcode=PD-101`
      )
    }
    this.setState({
      isModalOpen: false,
    })
  }

  render() {
    const data = MAP[this.props.listing.listing_status]
    if (!data) {
      return null
    }

    return (
      <Modal
        open={this.state.isModalOpen}
        mobileTitleSkin='light'
        onClose={this.handleClose}
        size='tiny'
        title={data.title}
      >
        <Modal.Content>
          <Text className={cx('u-mb-3')} content={data.content} color='gray' />
          <Button role='primary' onClick={this.handleClose}>
            Back to Search
          </Button>
        </Modal.Content>
      </Modal>
    )
  }
}
